// Holds the current application context and returns it via static accessors.
class ContextProvider {
    private context: any;

    // Singleton pattern: a single instance of the class is defined in order to ensure consistency over its state.
    private static instance: ContextProvider;
    private constructor() {}
    public static getInstance(): ContextProvider {
        // Lazily instantiate the singleton in order not to waste resources.
        if (!ContextProvider.instance) {
            ContextProvider.instance = new ContextProvider();
        }

        return ContextProvider.instance;
    }

    // Returns the instance's context.
    public static getContext(): any {
        return ContextProvider.getInstance().context;
    }

    // Sets the instance's context to the given one.
    public static setContext(context: any) {
        ContextProvider.getInstance().context = context;
    }
}

export default ContextProvider;